export const IconInstagram = ({
  width = 40,
  height = 40,
  color = 'var(--violet)',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.000488281' width={width} height={height} rx='20' fill={color} />
    <path
      d='M23.125 13.7505H16.875C15.1491 13.7505 13.75 15.1496 13.75 16.8755V23.1255C13.75 24.8514 15.1491 26.2505 16.875 26.2505H23.125C24.8509 26.2505 26.25 24.8514 26.25 23.1255V16.8755C26.25 15.1496 24.8509 13.7505 23.125 13.7505Z'
      stroke='#FAFAFC'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23.4378 16.563H23.4441M22.5003 19.6067C22.5774 20.1269 22.4886 20.6581 22.2464 21.1249C22.0042 21.5916 21.621 21.9701 21.1513 22.2065C20.6816 22.4429 20.1493 22.5252 19.6302 22.4417C19.111 22.3582 18.6314 22.113 18.2596 21.7412C17.8878 21.3694 17.6426 20.8898 17.5591 20.3706C17.4756 19.8515 17.5578 19.3192 17.7943 18.8495C18.0307 18.3798 18.4092 17.9966 18.8759 17.7544C19.3427 17.5122 19.8739 17.4234 20.3941 17.5005C20.9246 17.5792 21.4158 17.8264 21.7951 18.2057C22.1744 18.585 22.4216 19.0762 22.5003 19.6067Z'
      stroke='#FAFAFC'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
